<template>
  <b-modal size="xl" id="modal-pk" centered :title="title" hide-footer @show="openModal">
    <form @submit.prevent>
      <div class="mt-2" v-show="!submitLoading">
        <div class="card">
          <div class="card-header" ref="modalBRS">Detail</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-md-3 mt-3">
                <label>
                  Title <span class="text-danger">*</span>
                  <small> ({{ (payload.name || '').length }}/200) </small>
                </label>
                <input type="text" class="form-control" v-model="payload.name" name="Title" maxlength="200" v-validate="'required|max:200'" />
                <span class="text-sm text-danger" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>IM Number <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="payload.im_number" name="Number" v-validate="'required|max:200'" />
                <span class="text-sm text-danger" v-show="errors.has('Number')">{{ errors.first('Number') }}</span>
              </div>

              <div class="col-md-6 col-md-3 mt-3">
                <label>Category <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="payload.im_category" name="Category" disabled v-validate="'required|max:200'" />
                <span class="text-sm text-danger" v-show="errors.has('Category')">{{ errors.first('Category') }}</span>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Year <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="year" name="im_year" disabled />
              </div>

              <div class="col-md-12 col-md-6 mt-3">
                <label>Department</label>
                <input type="text" class="form-control" v-model="departmentName" name="departmentName" disabled />
                <!--              <v-select
                  :options="listDepartement"
                  v-model="payload.fund_center_id"
                  :reduce="(e) => e.value"
                  placeholder="Select/Type Here..."
                  class="w-md-auto"
              />-->
              </div>
              <div class="col-md-12 col-md-6 mt-3">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          Used IM Value
                          <span
                            v-b-popover.hover.right="
                              'Value yang didapatkan dari total PO value yang menggunakan referensi terhadap Internal Memo PK ini'
                            "
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," :value="imUsedValue" disabled />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          Remaining IM Value
                          <span
                            v-b-popover.hover.right="'Value sisa dari total relocation yang belum digunakan pada PO'"
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," :value="imRemainingValue" disabled />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          Total IM Value
                          <span
                            v-b-popover.hover.right="'Nilai Budget Relokasi total berdasarkan Internal Memo Attachment'"
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," :value="payload.relocate_value" disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
      <div class="card">
        <div class="card-header">
          Internal Memo Files
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-md-6 mt-3 d-flex justify-content-end align-items-end">
              <button type="button" class="btn btn-primary ml-2" @click="addAttachment()">Add attachment</button>
            </div>
            <div class="col-md-12 col-md-6 mt-3">
              <div class="form-group">
              <label>Internal Memo (DOCX/PDF) (max size: 10MB) <span class="text-danger">*</span></label>
              <input
                  type="file"
                  class="form-control"
                  v-validate="'required'"
                  ref="fileUpload"
                  name="File"
                  accept=".pdf,.docx"
                  multiple
                  @change="fileUploader($event, 'create')"
              />
              <span class="text-sm text-danger" v-show="errors.has('File')">
                {{ errors.first("File") }}
              </span>
              <span class="text-sm text-danger" v-if="fileError">
                {{ fileError }}
              </span>
              &lt;!&ndash; Display the list of selected files &ndash;&gt;
              <div v-if="payload.file && payload.file.length">
                <p>Selected Files:</p>
                <ul>
                  <li v-for="(file, index) in payload.file" :key="index">
                    {{ file.name }}
                  </li>
                </ul>
              </div>
            </div>
            </div>

          </div>
          <div class="row mt-3 mb-3" v-for="(item, index) in payload.attachment" :key="`attachment_${index}`">
            <div class="col-md-12 col-md-6 mt-3 mb-3">
              <label>
                <i style="cursor: pointer; font-size: 20px;" class="fe fe-trash text-danger mr-1" @click="removeAttachment(index)" />
                Lampiran {{index + 1 }} (DOCX/PDF) (max size: 10MB) <span class="text-danger">*</span>
              </label>

              <input
                  type="file"
                  class="form-control"
                  v-validate="'required'"
                  ref="fileUpload"
                  name="File"
                  accept=".pdf,.docx"
                  multiple
                  @change="fileUploader($event, 'create')"
              />
                <span class="text-sm text-danger" v-show="errors.has('File')">
                {{ errors.first("File") }}
                </span>
                <span class="text-sm text-danger" v-if="fileError">
                  {{ fileError }}
                </span>
              &lt;!&ndash; Display the list of selected files &ndash;&gt;
              <div v-if="payload.file && payload.file.length">
                <p>Selected Files:</p>
                <ul>
                  <li v-for="(file, index) in payload.file" :key="index">
                    {{ file.name }}
                  </li>
                </ul>
              </div>
            </div>

          </div>

        </div>
      </div>
      -->
        <div class="card">
          <div class="card-header">Internal Memo Files</div>
          <div class="card-body">
            <div class="col-md-12 col-md-6 mt-3 d-flex justify-content-end align-items-end">
              <button type="button" class="btn btn-primary ml-2" @click="addAttachment()">Add attachment</button>
            </div>
            <div class="row mb-3" v-for="(item, index) in attachmentElements" :key="`${item}`">
              <div class="col-md-12 col-md-6 mt-3 mb-3">
                <label>
                  <i
                    style="cursor: pointer; font-size: 20px"
                    class="fe fe-trash text-danger mr-1"
                    @click="removeAttachment(index)"
                    v-if="index !== 0"
                  />
                  {{ index == 0 ? 'Internal Memo (DOCX/PDF) (max size: 10MB)' : `Lampiran ${index} (DOCX/PDF) (max size: 10MB)` }}
                  <span class="text-danger">*</span>
                </label>

                <input
                  type="file"
                  class="form-control"
                  :ref="`fileUpload_${index}`"
                  :name="`Attachment_${index}`"
                  accept=".pdf,.docx"
                  @change="fileUploader($event, index)"
                />
                <span class="text-sm text-danger" v-if="fileErrors?.[`attachments_${index}`]">
                  {{ fileErrors?.[`attachments_${index}`] }}
                </span>
                <!-- Display the list of selected files -->
                <div v-if="payload.files?.[index]">
                  <p>Selected File:</p>
                  <ul>
                    <li>
                      <a v-if="payload.files?.[index]?.url" :href="payload.files?.[index]?.url || ''" target="_blank">
                        {{ payload.files?.[index]?.name ? payload.files?.[index]?.name : payload.files?.[index]?.filename }}
                      </a>
                      <span v-else>
                        {{ payload.files?.[index]?.name ? payload.files?.[index]?.name : payload.files?.[index]?.filename }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">Additional Budget</div>
          <div class="card-body">
            <div class="row mb-5">
              <template>
                <div class="select-btn">
                  <button
                    v-for="opt in optionsBudgetTask"
                    :key="opt.value"
                    type="button"
                    class="btn-opt primary"
                    :class="{ 'active-opt': optionsBudgetTaskSelected === opt.value }"
                    @click="selectOption(opt.value)"
                    :disabled="isoptionsBudgetTaskSelectDisable"
                  >
                    {{ opt.label }}
                  </button>
                </div>
              </template>
            </div>
            <div class="row">
              <div class="col-md-6 col-md-3">
                <label>Budget Plan</label>
                <input type="text" class="form-control" v-model="payload.plan_id" name="Category" hidden="hidden" disabled />
                <input type="text" class="form-control" v-model="planTitle" name="planTitle" disabled />
                <!--
                <v-select
                :options="listDepartement"
                v-model="payload.plan_id"
                :reduce="(e) => e.value"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                disabled="disabled"
              />-->
              </div>
              <div class="col-md-6 col-md-3">
                <label>GL Type</label>
                <v-select
                  :options="typeOf"
                  v-model="payload.budget_type"
                  placeholder="Select/Type Here..."
                  name="type"
                  class="w-md-auto"
                  @input="changeGLNew($event)"
                  :disabled="isUsedIM"
                />
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>GL Number</label>
                <v-select
                  :options="listGLNumber"
                  v-model="payload.gl_id"
                  :reduce="(e) => e.id"
                  placeholder="Select/Type Here..."
                  @input="selectedFund($event, '', payload.budget_type)"
                  class="w-md-auto"
                  :disabled="isUsedIM"
                />
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Budget Task</label>
                <span v-if="optionsBudgetTaskSelected === 'New Budget Task'">
                  <input type="text" class="form-control" v-model="payload.budget_task_name" name="budget_task_name" />
                </span>
                <span v-else>
                  <v-select
                    v-model="payload.code_plan_budget"
                    :options="listBudgetTask"
                    :reduce="(e) => e.code"
                    label="name"
                    placeholder="Select Budget Task"
                    class="w-md-auto"
                    @input="selectedTask($event)"
                    :disabled="isUsedIM"
                  />
                </span>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Month</label>
                <v-select :options="monthData" label="label" :reduce="(e) => e.value" v-model="payload.month" :disabled="isUsedIM"></v-select>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Internal Memo Value</label>
                <RupiahInput
                  name="relocate_value"
                  v-model="payload.relocate_value"
                  v-validate="'numeric|max_value:999999999999999'"
                  @input="handleInputRelocateValue"
                />
                <FieldError name="relocate_value" label="Relocation Value" :errorBags="errors" />
                <span class="text-sm text-danger" v-show="isValidPOValue"> the Internal Memo Value cannot be smaller than the Used IM Value </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end" v-if="!submitLoading">
        <button type="button" class="btn btn-outline-secondary" @click="closeConfirmModal">Cancel</button>
        <button class="btn btn-primary ml-2" :disabled="submitLoading" @click="saveData">Submit</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axiosIns from '@/api/axios';
import FieldError from '@/components/helpers/fieldError.vue';
import RupiahInput from '@/components/helpers/rupiahInput.vue';

export default {
  name: 'ModalFormPK',
  components: { RupiahInput, FieldError },
  props: { rowId: Number || null },
  /*props: {
    /!*department: String, listDepartment: Array, type: String, recipients: Array *!/
  },*/
  data() {
    return {
      isUsedIM: false,
      isValidPOValue: false,
      isLoading: false,
      isEdit: false,
      detail: [],
      isoptionsBudgetTaskSelectDisable: false,
      optionsBudgetTaskSelected: 'Existing Budget Task',
      /*optionsBudgetTask: [
        { label: 'Existing Budget Task', value: 'Existing Budget Task' },
        { label: 'New Budget Task', value: 'New Budget Task' },
      ],*/
      optionsBudgetTask: [{ label: 'Existing Budget Task', value: 'Existing Budget Task' }],
      year: '',
      title: '',
      attachmentElements: [],
      fileErrors: {},
      listGLNumber: [],
      listBudgetTask: [],
      fundByOPEX: [],
      fundByCAPEX: [],
      activePlan: [],
      planTitle: '',
      departmentName: '',
      typeOf: ['OPEX', 'CAPEX'],
      listDepartement: [],
      monthData: [
        {
          label: 'January',
          value: 'jan',
        },
        {
          label: 'February',
          value: 'feb',
        },
        {
          label: 'March',
          value: 'mar',
        },
        {
          label: 'April',
          value: 'apr',
        },
        {
          label: 'May',
          value: 'may',
        },
        {
          label: 'June',
          value: 'jun',
        },
        {
          label: 'July',
          value: 'jul',
        },
        {
          label: 'August',
          value: 'aug',
        },
        {
          label: 'September',
          value: 'sef',
        },
        {
          label: 'October',
          value: 'oct',
        },
        {
          label: 'November',
          value: 'nov',
        },
        {
          label: 'December',
          value: 'dec',
        },
      ],
      payload: {
        im_budget_id: '',
        im_number: '',
        name: '',
        im_category: 'Pengajuan Khusus',
        im_year: '',
        files: [],
        department: [],
        attachment: [],
        relocate_value: '',
        im_projects: [],
        fund_center_id: '',
        plan_id: '',
        budget_type: '',
        gl_id: '',
        code_plan_budget: '',
        budget_task_name: '',
        budget_task_id: '',
        month: '',
        fund_id: '',
        budget_actuals: [],
      },
      uploading: false,
      uploadingProgress: 0,
      submitLoading: false,
      im_projects: {
        project_name: '',
        type: '',
        relocate_value: 0,
        im_used_value: 0,
        im_remaining_value: 0,
        relocation_status: '',
        fullfilled_status: '',
        project_relocation: [],
      },
      project_relocation: [
        {
          project_name: '',
          type: '',
          relocate_value: 0,
          im_used_value: 0,
          im_remaining_value: 0,
          relocation_status: '',
          fullfilled_status: '',
        },
      ],
    };
  },
  async mounted() {
    if (this.isLoading) {
      await this.getListDepartment();
      await this.getActivePlan();
    }
  },
  computed: {
    dataDetail() {
      if (this.rowId) return this.$store.getters['imNumber/detail'] || {};
    },
    isFilledFields() {
      let result = false;
      if (this.payload.plan_id) return true;
      if (this.payload.fund_center_id) return true;
      if (this.payload.budget_type) return true;
      if (this.payload.gl_id) return true;
      if (this.payload.code_plan_budget) return true;
      if (this.payload.month) return true;
      return result;
    },
    isSelectedExistingBudgetTask() {
      return this.optionsBudgetTaskSelected === 'Existing Budget Task' && this.isFilledFields;
    },
    isSelectedNewBudgetTask() {
      return this.optionsBudgetTaskSelected === 'New Budget Task' && this.isFilledFields;
    },
    imUsedValue() {
      return this.dataDetail?.budget_actuals?.reduce((total, item) => total + Number(item.po_value), Number(0)) || 0;
    },
    imRemainingValue() {
      return Number(this.dataDetail?.relocate_value) - Number(this.imUsedValue) || 0;
    },
  },
  watch: {},
  methods: {
    checkOptionSelected() {
      let result = false;
      if (this.payload.budget_type) result = true;
      this.isoptionsBudgetTaskSelectDisable = result;
    },
    selectOption(val) {
      this.optionsBudgetTaskSelected = val;
    },
    async openModal() {
      this.isUsedIM = false;
      if (this.rowId) {
        this.isEdit = true;
        this.getDetail();
        this.title = 'Edit Internal Memo Pengajuan Khusus';
      } else {
        this.resetFormAll();
        this.addAttachment();
        this.title = 'Add Internal Memo Pengajuan Khusus';
        this.isEdit = true;
        await this.getListDepartment();
        await this.getActivePlan();
        this.checkOptionSelected();
      }
    },
    getDetail() {
      if (this.rowId) {
        this.$store.dispatch('imNumber/GET_DETAIL', this.rowId).then(() => {
          this.mappingToPayload();
        });
      }
    },
    async mappingToPayload() {
      try {
        this.isUsedIM = false;
        this.detail = this.dataDetail;
        const currentYear = new Date().getFullYear();
        this.year = this.dataDetail?.im_year || currentYear;
        this.isLoading = true;
        await this.getEditActivePlan(this.dataDetail?.departments[0]?.id, this.year);
        this.payload = {
          fund_id: this.dataDetail?.im_budget.fund_id,
          im_budget_id: this.dataDetail?.im_budget.id,
          im_number: this.dataDetail?.im_number,
          name: this.dataDetail?.name,
          //budget_task_id: this.dataDetail?.im_budget?.budget_task_id ? this.dataDetail?.im_budget?.budget_task_id.toString() : '',
          budget_task_name: this.dataDetail?.im_budget?.budget_task_name,
          im_category: 'Pengajuan Khusus',
          im_year: this.dataDetail?.im_year || currentYear,
          files: this.dataDetail?.attachments,
          department: [],
          attachment: this.dataDetail?.attachments,
          relocate_value: this.dataDetail?.im_budget?.relocate_value,
          im_projects: [],
          fund_center_id: this.dataDetail?.im_budget?.fund_center_id,
          plan_id: this.dataDetail?.im_budget?.taskDetail?.plan_id,
          budget_type: this.dataDetail?.im_budget?.taskDetail?.budget_type,
          gl_id:
            this.dataDetail?.im_budget?.taskDetail?.budget_type === 'OPEX'
              ? this.dataDetail?.im_budget?.opex_gl_id
              : this.dataDetail?.im_budget?.capex_gl_id,
          code_plan_budget: this.dataDetail?.im_budget?.code_plan_budget,
          month: this.dataDetail?.im_budget?.month,
          budget_actuals: this.dataDetail?.budget_actuals,
        };
        let dtas;
        if (this.dataDetail?.im_budget?.taskDetail?.budget_type) {
          if (this.dataDetail?.im_budget?.taskDetail?.budget_type === 'OPEX') {
            this.listGLNumber = this.fundByOPEX;
          } else {
            this.listGLNumber = this.fundByCAPEX;
          }
        }
        if (this.payload.budget_type === 'OPEX') {
          dtas = this.fundByOPEX?.filter((e) => e.id === this.payload.gl_id);
          this.listBudgetTask = dtas[0].budget_task || [];
        } else {
          dtas = this.fundByCAPEX?.filter((e) => e.id === this.payload.gl_id);
          this.listBudgetTask = dtas[0].budget_task || [];
        }
        for (let i = 0; i < this.dataDetail?.attachments.length; i++) {
          this.addAttachment();
        }
        this.checkOptionSelected();
        if (this.dataDetail?.budget_actuals && this.dataDetail?.budget_actuals.length > 0) {
          this.isUsedIM = true;
        }
      } catch (error) {
        console.error('Error processing dataDetail:', error);
      }
    },
    resetFormAll() {
      this.payload = {
        im_number: '',
        name: '',
        im_category: 'Pengajuan Khusus',
        //im_year: '',
        files: [],
        departments: [],
        relocate_value: '',
        im_projects: [],
      };
      this.attachmentElements = [];
    },
    countSum() {
      this.payload.relocate_value = this.payload.relocate_value || 0;
    },
    async getListDepartment() {
      try {
        const response = await axiosIns.get('/fund-center/list-department');
        this.listDepartement = response.data.data
          .sort((a, b) => a.department_code.localeCompare(b.department_code)) // ASC sort
          .map((items) => ({
            label: `${items.department_code} - ${items.organization}`,
            value: items.id,
            row: items,
          }));
      } catch (error) {
        console.error('Failed to fetch year options:', error);
      }
    },
    newIMProjects() {
      this.payload.im_projects.push({
        project_name: '',
        type: '',
        relocate_value: 0,
        im_used_value: 0,
        im_remaining_value: 0,
        relocation_status: '',
        fullfilled_status: '',
        project_relocation: [],
      });
    },
    newProjectRelocation(index) {
      this.payload.im_projects[index].project_relocation.push({
        project_name: '',
        type: '',
        relocate_value: 0,
        im_used_value: 0,
        im_remaining_value: 0,
        relocation_status: '',
        fullfilled_status: '',
        fund_center_id_from: '',
        fund_center_id_to: '',
      });
    },
    removeIMProjects(i) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.payload.im_projects.splice(i, 1);
            this.$swal('Deleted!', 'Project has been deleted', 'success');
          } catch (e) {
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    /*removeAttachment(i) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.payload.attachment.splice(i, 1);
            this.$swal("Deleted!", "Attachment has been deleted", "success");
          }catch (e) {
            this.$swal("Error", "Error while delete data", "error");
          }
        }
      })
    },*/
    /*addAttachment() {
      this.payload.attachment.push({
        project_name: '',
        type: '',
        relocate_value: 0,
        im_used_value: 0,
        im_remaining_value: 0,
        relocation_status: '',
        fullfilled_status: '',
      });
    },*/
    addAttachment() {
      this.attachmentElements.push(`attachment_${this.attachmentElements.length}`);
    },
    removeAttachment(i) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.attachmentElements.splice(i, 1);
            this.payload.files.splice(i, 1); // remove index > 0
            this.$swal('Deleted!', 'Attachment has been deleted', 'success');
          } catch (e) {
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    closeConfirmModal(evt) {
      this.$swal({
        title: 'Are you sure ?',
        text: 'This form BRS will be canceled',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: `Yes, i'm sure!`,
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          //this.resetPayload();
          this.$emit('hide-modal');
        }
      });
    },
    /* async fileUploader(event, type = 'create') {
      const files = event.target.files;
      const validFiles = [];
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      const allowedTypes = [
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ];

      // Clear any previous error
      this.fileError = "";

      // Loop through selected files for validation
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Validate file size
        if (file.size > maxSize) {
          this.fileError = "File size must be less than 5MB.";

          this.$swal.fire({
            title: 'Error',
            text: "File size must be less than 5MB.",
            icon: 'error',
            confirmButtonText: 'OK'
          });

          this.$refs.fileUpload.value = ""; // Reset file input
          return;
        }

        // Validate file type
        if (!allowedTypes.includes(file.type)) {
          this.fileError = "Only PDF or DOCX files are allowed.";
          this.$refs.fileUpload.value = ""; // Reset file input

          this.$swal.fire({
            title: 'Error',
            text: "Only PDF or DOCX files are allowed.",
            icon: 'error',
            confirmButtonText: 'OK'
          });

          return;
        }

        validFiles.push(file);
      }
      // If all files are valid, assign the array of files
      if (type === "create") {
        this.modalCreate.file = validFiles;
      } else if (type === "update") {
        this.modalUpdate.file = validFiles;
      }
    },*/
    async fileUploader(event, index = 0) {
      const file = event.target.files[0];
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      if (!file) {
        this.fileErrors[`attachments_${index}`] = 'File is required';
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        this.fileErrors[`attachments_${index}`] = 'File size must be less than 5MB.';

        this.$swal.fire({
          title: 'Error',
          text: 'File size must be less than 5MB.',
          icon: 'error',
          confirmButtonText: 'OK',
        });

        this.$refs[`fileUpload_${index}`].value = ''; // Reset file input
        this.payload.files[index] = null;
        return;
      }

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        this.fileErrors[`attachments_${index}`] = 'Only PDF or DOCX files are allowed.';
        this.$refs.fileUpload.value = ''; // Reset file input

        this.$swal.fire({
          title: 'Error',
          text: 'Only PDF or DOCX files are allowed.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        this.$refs[`fileUpload_${index}`].value = ''; // Reset file input
        this.payload.files[index] = null;
        return;
      }
      this.payload.files[index] = file;
      // Trigger reactivity
      this.$forceUpdate();
    },
    async getActivePlan() {
      try {
        const currentYear = new Date().getFullYear();
        const responsActivePlan = await axiosIns.get('/plan/active-plan');
        this.activePlan = responsActivePlan?.data?.data;
        const response = await axiosIns.get(`/plan/find-by-fund-center-year/${this.activePlan?.fund_center_id}/${currentYear}`);

        const dt = response?.data?.data;
        this.payload.plan_id = dt?.id || 0;
        this.payload.fund_center_id = dt?.fund_center?.id || 0;
        this.planTitle = dt?.title || '';
        this.year = currentYear;
        this.departmentName = this.activePlan?.fund_center?.department_name || '';
        if (this.payload.plan_id > 0 && this.payload.fund_center_id > 0) {
          await Promise.all([
            this.$store.dispatch('opexGL/GET_LIST_DATA_BOX', { id: this.payload.plan_id, fundCenterId: this.activePlan?.fund_center_id }),
            this.$store.dispatch('capexGL/GET_LIST_DATA_BOX', { id: this.payload.plan_id, fundCenterId: this.activePlan?.fund_center_id }),
          ]);
          const opexRows = this.$store.getters['opexGL/listData'] || [];
          const capexRows = this.$store.getters['capexGL/listData'] || [];
          let tempOpexList = [];
          let tempCapexList = [];
          if (opexRows && opexRows.length > 0) {
            opexRows?.map((item) => {
              item?.budgetItems?.map((i) => {
                tempOpexList.push({
                  id: String(i?.opex_gl[0]?.id),
                  fund: i?.opex_gl[0]?.fund,
                  label: `${i?.opex_gl[0]?.gl_code} - ${i.budget_item || ''}`,
                  gl_code: i?.opex_gl[0]?.gl_code,
                  budget_task: i?.opex_gl[0]?.budget_task,
                });
              });
            });
          }
          if (capexRows && capexRows.length > 0) {
            capexRows?.map((item) => {
              item?.gl_code?.map((i) => {
                tempCapexList.push({
                  id: String(i?.id),
                  fund: i?.fund,
                  label: `${i?.gl_code} - ${i.account?.account || ''}`,
                  gl_code: i?.gl_code,
                  budget_task: i?.budget_task,
                });
              });
            });
          }
          this.fundByOPEX = tempOpexList;
          this.fundByCAPEX = tempCapexList;
        }
      } catch (error) {
        console.error('Failed to fetch active plan:', error);
      }
    },
    async getEditActivePlan(fund_center_id, year) {
      try {
        //const currentYear = new Date().getFullYear();
        //const responsActivePlan = await axiosIns.get('/plan/active-plan');
        //this.activePlan = responsActivePlan?.data?.data;
        const response = await axiosIns.get(`/plan/find-by-fund-center-year/${fund_center_id}/${year}`);

        const dt = response?.data?.data;
        this.payload.plan_id = dt?.id || 0;
        this.payload.fund_center_id = dt?.fund_center?.id || 0;
        this.planTitle = dt?.title || '';
        //this.year = currentYear;
        this.departmentName = dt?.fund_center?.department_name || '';
        if (this.payload.plan_id > 0 && this.payload.fund_center_id > 0) {
          await Promise.all([
            this.$store.dispatch('opexGL/GET_LIST_DATA_BOX', { id: this.payload.plan_id, fundCenterId: fund_center_id }),
            this.$store.dispatch('capexGL/GET_LIST_DATA_BOX', { id: this.payload.plan_id, fundCenterId: fund_center_id }),
          ]);
          const opexRows = this.$store.getters['opexGL/listData'] || [];
          const capexRows = this.$store.getters['capexGL/listData'] || [];
          let tempOpexList = [];
          let tempCapexList = [];
          if (opexRows && opexRows.length > 0) {
            opexRows?.map((item) => {
              item?.budgetItems?.map((i) => {
                tempOpexList.push({
                  id: String(i?.opex_gl[0]?.id),
                  fund: i?.opex_gl[0]?.fund,
                  label: `${i?.opex_gl[0]?.gl_code} - ${i.budget_item || ''}`,
                  gl_code: i?.opex_gl[0]?.gl_code,
                  budget_task: i?.opex_gl[0]?.budget_task,
                });
              });
            });
          }
          if (capexRows && capexRows.length > 0) {
            capexRows?.map((item) => {
              item?.gl_code?.map((i) => {
                tempCapexList.push({
                  id: String(i?.id),
                  fund: i?.fund,
                  label: `${i?.gl_code} - ${i.account?.account || ''}`,
                  gl_code: i?.gl_code,
                  budget_task: i?.budget_task,
                });
              });
            });
          }
          this.fundByOPEX = tempOpexList;
          this.fundByCAPEX = tempCapexList;
        }
      } catch (error) {
        console.error('Failed to fetch active plan:', error);
      }
    },
    selectedFund(evt) {
      let dtas;
      this.listBudgetTask = [];
      if (this.payload.code_plan_budget) {
        this.payload.code_plan_budget = '';
        this.payload.budget_task_id = '';
      }
      if (this.payload.budget_type === 'OPEX') {
        dtas = this.fundByOPEX?.filter((e) => e.id === evt);
        this.listBudgetTask = dtas[0].budget_task || [];
      } else {
        dtas = this.fundByCAPEX?.filter((e) => e.id === evt);
        this.listBudgetTask = dtas[0].budget_task || [];
      }

      this.checkOptionSelected();
    },
    selectedTask(taskId) {
      const dt = this.listBudgetTask.find((i) => i.code === taskId);
      this.payload.code_plan_budget = dt?.code;
      //this.payload.budget_task_id = taskId;
      //this.checkOptionSelected();
    },
    changeGLNew(evt) {
      this.payload.gl_id = '';
      this.listGLNumber = [];
      this.listBudgetTask = [];

      if (this.payload.code_plan_budget) {
        this.payload.code_plan_budget = '';
        this.payload.budget_task_id = '';
        this.payload.gl_id = '';
        this.payload.budget_task_name = '';
      }
      if (evt) {
        if (evt === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;
        } else {
          this.listGLNumber = this.fundByCAPEX;
        }
      }
      this.checkOptionSelected();
    },
    handleInputRelocateValue(value) {
      if (value.includes('e') || value < 0) {
        this.payload.relocate_value = value.replace(/[^0-9]/g, ''); // Menghapus karakter selain angka
      } else {
        this.payload.relocate_value = value;
      }
    },
    getListBoxOpexRealization(planId, fundCenterId) {
      if (planId && fundCenterId) {
        this.$store.dispatch('ttAccount/GET_LIST_BOX_OPEX_REALIZATION', {
          planId: planId,
          fundCenterId: fundCenterId,
        });
      }
    },
    getListBoxCapexRealization(planId, fundCenterId) {
      this.$store.dispatch('ttAccount/GET_LIST_BOX_CAPEX_REALIZATION', {
        planId: planId,
        fundCenterId: fundCenterId,
      });
    },
    scrollToTopSmooth() {
      const modalContent = this.$refs.modalBRS;
      if (!modalContent) return;

      modalContent.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    },
    async saveData() {
      this.fileErrors = {};
      this.isValidPOValue = false;
      const valid = await this.$validator.validateAll();
      if (this.attachmentElements.length > 0) {
        this.attachmentElements.forEach((el, index) => {
          const fileObject = this.payload.files?.[index]?.name || this.payload.files?.[index]?.filename;
          if (!fileObject && index === 0) {
            this.fileErrors[`attachments_${index}`] = 'File is required';
          }
        });
      }
      this.$forceUpdate();
      if (!valid || Object.keys(this.fileErrors).length > 0) {
        this.scrollToTopSmooth();
        console.error('Validation error:', this.errors);
        return;
      }
      if (this.isEdit && this.imUsedValue) {
        if (BigInt(this.payload.relocate_value ?? 0) < BigInt(this.imUsedValue ?? 0)) {
          this.isValidPOValue = true;
          return;
        }
      }
      /*if (this.payload?.budget_actuals) {
        if (this.payload?.budget_actuals[0]?.po_value) {
          if (BigInt(this.payload.relocate_value ?? 0) < BigInt(this.payload.budget_actuals[0]?.po_value ?? 0)) {
            this.isValidPOValue = true;
            return;
          }
        }
      }*/

      try {
        this.isLoading = true;
        // Create payload
        const formData = new FormData();
        formData.append('name', this.payload.name);
        formData.append('im_number', this.payload.im_number);
        formData.append('im_category', this.payload.im_category);
        formData.append('im_year', this.year);
        formData.append('relocate_value', this.payload.relocate_value);
        formData.append('transaction_type', this.optionsBudgetTaskSelected);
        formData.append('budget_task_name', this.payload.budget_task_name || '');
        formData.append('fund_center_id', this.payload.fund_center_id || this.activePlan?.fund_center_id);
        formData.append('plan_id', this.payload.plan_id || this.activePlan?.id);
        formData.append('budget_type', this.payload.budget_type);
        formData.append('month', this.payload.month);
        formData.append('budget_task_id', this.payload.budget_task_id || '');
        formData.append('code_plan_budget', this.payload.code_plan_budget || '');
        formData.append('gl_id', this.payload.gl_id || '');
        formData.append('im_budget_id', this.payload.im_budget_id || '');
        formData.append('fund_id', this.payload.fund_id || '');

        // Append each selected file
        this.payload.files.forEach((file, index) => {
          if (file instanceof File) {
            formData.append(`attachment_${index}`, file);
          } else {
            formData.append('files', JSON.stringify(file));
          }
        });

        // Append attachment elements for comparison in backend
        formData.append('attachment_elements', JSON.stringify(this.attachmentElements));

        await this.$store
          .dispatch(this.rowId ? 'imNumber/UPDATE_DATA_PK' : 'imNumber/CREATE_DATA_PK', this.rowId ? { id: this.rowId, data: formData } : formData)
          .then((resp) => {
            this.$swal('Saved', 'Your input has been saved', 'success').then(() => {
              this.submitLoading = false;
              this.resetFormAll();
              this.$emit('get-list-im');
              this.$emit('get-list-year');
              this.$emit('get-list-department');
              this.$emit('hide-modal');
            });
          })
          .catch((error) => {
            this.isLoading = false;
            const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
            });
            console.error('Error:', error);
          });
      } catch (error) {
        const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
        });
        console.error('Error:', error);
      }
    },
  },
};
</script>
<style scoped>
.select-btn {
  display: flex;
  gap: 3px;
}

.btn-opt {
  padding: 6px 14px;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
  border-radius: 4px;
}

.btn-opt.active-opt {
  background: #af0404;
  color: white;
  border-color: #409eff;
}
</style>
